import React from "react";
import { ThemeProvider } from "@material-ui/styles";
import { ToastContainer } from "react-toastify";
import RouterNeocredit from "./routes/Router";
import "react-toastify/dist/ReactToastify.css";
import theme from "./styles/theme";
import ProvideAuth from "./auth/ProvideAuth";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
        <ProvideAuth>
          <>
            <RouterNeocredit />
            <ToastContainer
              position="top-right"
              autoClose={4000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </>
        </ProvideAuth>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
}
